import React, { useContext, useEffect } from "react";
import { useParams } from "react-router";
import {
	TransactionContext,
	TransactionResourceType,
} from "src/pages/App/pages/Organization/components/Transaction/Context/TransactionContext";
import AttachmentsCard from "../../../../../../../../../../components/Attachment/AttachmentsCard";
import { TransferContext } from "../../pages/Preview";
import TransferBasicInfoCard from "../TransferPreview/TransferBasicInfoCard";
import TransferItemsCard from "../TransferPreview/TransferItemsCard";

interface MatchParams {
	transferId: string;
}

const TransferPreviewTab = () => {
	const { transfer, onFetchTransfer } = useContext(TransferContext);
	const { setListItemId, setTransactionResourceType } = useContext(TransactionContext);
	const { transferId } = useParams<MatchParams>();

	useEffect(() => {
		setListItemId(transferId);
		setTransactionResourceType(TransactionResourceType.TRANSFER);
		onFetchTransfer();
	}, []);

	return (
		<div className="col px-0">
			<TransferBasicInfoCard />
			{transfer?.items?.length > 0 && <TransferItemsCard />}
			{transfer?.file_attachments?.length > 0 && <AttachmentsCard attachments={transfer.file_attachments} />}
		</div>
	);
};

export default TransferPreviewTab;
